const EMPTY_STR = "";
const DEFAULT_CONTENT = EMPTY_STR;
const DEFAULT_PREFIX = "{";
const DEFAULT_SUFFIX = "}";
// const ERROR_FILTER_NAME = "replaceContent filter: ";
// const ERROR_VALUE_OF = "value of token '";
// const ERROR_VALUE_IS = "' is null or undefined.";
const ESCAPED_OPEN_BRACKET = "\\{";
const ESCAPED_CLOSED_BRACKET = "\\}";

const performContentSubstition = (tokenMap, prefix, suffix, content) => {
	let pattern = EMPTY_STR;
	let patternRegex = EMPTY_STR;
	let substitutionToken = EMPTY_STR;
	let escapedSubstitutionToken = EMPTY_STR;
	let currentToken = EMPTY_STR;
	let key = EMPTY_STR;

	for (key in tokenMap) {
		pattern = prefix + key + suffix;

		//use regex to replace all occurrences 'g'lobally
		patternRegex = new RegExp(pattern, "g");

		currentToken = tokenMap[key];
		if (currentToken) {
			substitutionToken = currentToken.toString();
			//Escaping $ with $$$$ because $ is a meta character and we want to preserve $ in the final substitution $$$$ -> $$ -> $
			escapedSubstitutionToken = substitutionToken.replace(/\$/g, "$$$$");
		} else {
			escapedSubstitutionToken = EMPTY_STR;
		}

		content = content.replace(patternRegex, escapedSubstitutionToken);
	}
	return content;
};

export default function replaceContent(content, tokenMap) {
	let prefix;
	let suffix;

	if (typeof tokenMap === "object") {
		//swap nulls and undefined with defaults to avoid errors
		content = content || DEFAULT_CONTENT;
		tokenMap = tokenMap || {};
		prefix = DEFAULT_PREFIX;
		suffix = DEFAULT_SUFFIX;

		//If using array replacement notation ('{0}'), escape the {} for the regex.
		if (tokenMap instanceof Array && prefix === "{") {
			prefix = ESCAPED_OPEN_BRACKET;
			suffix = ESCAPED_CLOSED_BRACKET;
		}

		if (content) {
			content = performContentSubstition(tokenMap, prefix, suffix, content);
		}
	}

	return content;
}
